@if (filteredServices().length || isLoading()) {
  <div class="grouped-services mb-big">
    <div class="px-plus">
      <common-ui-components-title-summary
        [isLoading]="isLoading()"
        [title]="category().description ?? ''"
        [showButton]="false"
      ></common-ui-components-title-summary>
    </div>
    @if (!isLoading()) {
      <div class="grouped-services-items px-atom">
        <common-ui-components-horizontal-scroll [classes]="'gap-minus pt-low pr-plus'">
          @for (service of filteredServices(); track $index) {
            <common-app-services-frequent-services-preview
              (clicked)="handleClickOnService($event)"
              [isBig]="true"
              [frequentService]="service"
              [badge]="service.badge"
            ></common-app-services-frequent-services-preview>
          }
        </common-ui-components-horizontal-scroll>
      </div>
    } @else {
      <div class="d-flex align-items-center justify-content-center gap-minus">
        @for (item of rangeCreator(4); track $index) {
          <common-app-services-frequent-services-preview
            [isBig]="true"
            [isLoading]="true"
          ></common-app-services-frequent-services-preview>
        }
      </div>
    }
  </div>
}
